import $ from 'jQuery';

$(function () {
    const tooltipData = JSON.parse($('#tooltip-storage').attr('data-tooltips'));
    const $tooltipDiv = $('#form-tooltip');

    $('#frm-contact-form-category').on('change', function () {
        const selectedValue = $(this).val();
        $tooltipDiv.text(tooltipData[selectedValue] || "");
    });

    $('#frm-contact-form').on('submit', function (event) {
        let $submitButton = $(this).find('[type="submit"]');
        console.log($submitButton);
        console.log($submitButton.length);
        if ($submitButton.length) {
            $submitButton.prop('disabled', true).val('Odesílání...');
        }
    });
});
